import { memoize } from 'lodash';
import { getData, ASN } from './common';

export const getAsName = memoize(async (asn: ASN) => {
  return getData<ASNames>('as-names', {
    resource: asn.toString(),
  })
    .then(({ names }) => ('' === names[asn] ? null : names[asn]))
    .catch(() => null);
});

interface ASNames {
  names: {
    [key: string]: string;
  };
}
